import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onBeforeUnmount } from 'vue'
import { SKIP_MODE_OPTIONS } from '@/util/scheduleFutureSlots'

interface FutureSlotRow {
  status: string
  label: string
  removable: boolean
  color: string
  count: number
  remove: boolean
  create_overlap: boolean
  skip_mode: string
}


const __default__ = { name: 'ReviewFutureSlotsDrawer' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  show: { type: Boolean, default: false },
  rows: { type: Array as () => FutureSlotRow[], default: () => [] },
  confirmLabel: { type: String, default: 'Confirm' },
  insufficientResources: { type: Boolean, default: false },
  loading: { type: Boolean, default: false }
},
  emits: ['close', 'confirm'],
  setup(__props, { emit }) {

const props = __props




// The parent owns the rows; toggles mutate them in place.

// Sections with no slots start collapsed; the operator can still open them.
const expanded = ref<Record<string, boolean>>({})
const resetExpanded = () => {
  const next: Record<string, boolean> = {}
  props.rows.forEach(r => { next[r.status] = r.count > 0 })
  expanded.value = next
}
const setExpanded = (status: string, val: boolean) => {
  expanded.value = { ...expanded.value, [status]: val }
}
watch(() => props.rows, resetExpanded, { immediate: true })
const onEscKey = (e: KeyboardEvent) => {
  if (e.key === 'Escape' && props.show) emit('close')
}
watch(() => props.show, (val) => {
  if (val) document.addEventListener('keydown', onEscKey)
  else document.removeEventListener('keydown', onEscKey)
})
onBeforeUnmount(() => document.removeEventListener('keydown', onEscKey))

return { __sfc: true,props, emit, expanded, resetExpanded, setExpanded, onEscKey, SKIP_MODE_OPTIONS }
}

})